export default __webpack_public_path__ + "static/media/mcrsft.9b7b29cc.jpg";